
























import BaseMinMaxField from '@/views/Company/Settings/Narrowcasting/Collections/BaseMinMaxField.vue'
import { Component } from 'vue-property-decorator'

@Component
export default class RoomsField extends BaseMinMaxField {
    get fieldName(): string {
        return 'rooms'
    }
}
